<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M5.30108 15.3463C6.24618 15.3463 7.01231 14.5802 7.01231 13.6351C7.01231 12.69 6.24618 11.9238 5.30108 11.9238C4.35599 11.9238 3.58984 12.69 3.58984 13.6351C3.58984 14.5802 4.35599 15.3463 5.30108 15.3463Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M13.0023 13.2072C13.9473 13.2072 14.7135 12.441 14.7135 11.496C14.7135 10.5508 13.9473 9.78467 13.0023 9.78467C12.0571 9.78467 11.291 10.5508 11.291 11.496C11.291 12.441 12.0571 13.2072 13.0023 13.2072Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14.7135 11.4957V4.78771C14.7131 4.72225 14.6977 4.65775 14.6684 4.59916C14.6393 4.54059 14.597 4.48949 14.5449 4.44983C14.4929 4.41015 14.4323 4.38296 14.3681 4.37033C14.3039 4.35771 14.2376 4.36 14.1744 4.37701L10.752 5.32675"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14.7132 6.79004L8.48047 8.52136"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M5.44294 2.96792C5.95132 2.28105 6.26412 0.877441 6.26412 0.877441C6.26412 0.877441 6.57692 2.28105 7.0853 2.96791C7.59777 3.66031 9.23137 4.26654 9.23137 4.26654C9.23137 4.26654 7.59777 4.87278 7.0853 5.56518C6.57691 6.25204 6.26412 7.65566 6.26412 7.65566C6.26412 7.65566 5.95132 6.25204 5.44294 5.56518C4.93047 4.87279 3.29688 4.26655 3.29688 4.26655C3.29688 4.26655 4.93047 3.66032 5.44294 2.96792Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.01172 13.6349V10.1611"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M2.29492 7.56934V10.1615"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M0.998047 8.86523H3.59019"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
